define.alias("ember-drag-sort/services/drag-sort", "settings/services/drag-sort");